<div class="no-data-container" *ngIf="dataSource?.data?.length == 0 || dataSource == null">
  <mat-icon class="no-data-icon">search_off</mat-icon>
  <p class="no-data-text">No se encontraron datos para mostrar.</p>
</div>
